import { CDN_LINK } from '@globalConfig';
import stl from './SingleRatingBox.module.css';
import useHelpers from "@hooks/useHelpers";
import {useTranslation} from "@i18n";

const SingleRatingBox = (props) => {
  const {  isMobileLink, onClick, closeFunction, className, name, location, carName, carYear, carCondition, date, paragraph } = props;
  const {createUrl} = useHelpers();
  const {t} = useTranslation();
  return (
      <>
        {!isMobileLink ? (
            <div
                onClick={onClick}
                className={[
                  stl.singleRpContainer,
                  className ? className : undefined,
                ].join(' ')}>
              {closeFunction && (
                  <span className={stl.clsURPPopUp}>
              <span onClick={closeFunction}>close</span>
            </span>
              )}
              <div>
                <strong className={stl.Name}>{name}</strong>
                <span>{location}</span>
              </div>
              <div>
                <div className={stl.wrapper}>
              <span>
                {carName} {carYear}
              </span>
                  <span>{carCondition}</span>
                </div>
                <span>{date}</span>
              </div>

              <p>{paragraph}</p>
            </div>
        ) : (
            <div
                className={[
                  stl.singleRpContainer,
                  stl.showMoreSlide,
                  className ? className : undefined,
                ].join(' ')}>
              <a href={createUrl('/feedback')}>
            <span>
              <span>
                {t('اقرأ المزيد من التقييمات', { ns: 'web_home' })}
              </span>
              <img src={CDN_LINK + '/assets/images/arrGo.svg'} alt="" />
            </span>
              </a>
            </div>
        )}
      </>
  );
};

export default SingleRatingBox;
